import React from 'react';
import { DescriptionColumn } from './description-column';
import { ProviderColumn } from './provider-column';
import { Row } from './row';

export const ProcessingFeeRow = ({ providers, processingFee }) => (
  <Row paddingBottom={'10px'}>
    <DescriptionColumn fontSize={16} isBold={false}>
      Processing Fee
    </DescriptionColumn>
    <ProviderColumn colSpan={providers.length} isBold={false}>
      {processingFee}
    </ProviderColumn>
  </Row>
);
